/**
 * Название пантона по цвету формы из палитры Pantone Solid Coated:
 * «186 C» → «186», «Cool Gray 11 C» → «Cool Gray 11», технический цвет («Cyan») — как есть.
 */
export function getPantoneNameByFormColor(colorName?: string | null) {
    return (colorName ?? '').trim().replace(/\s+C$/, '')
}
